module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-1-es-MX-474eb7a396ce2f840dd4543e1d197a80.png";